<template>
  <messages-list :chat-list="doctorChatList"
                  class="root-doctor-messages"/>
</template>

<script>
  import MessagesList from '@/views/messages/messages-list';

  export default {
    name: 'root-doctor-messages',
    components: {
      MessagesList,
    },
    props: {
      chatList: {type: Array, default: () => []},
    },
    data() {
      return {
        doctorChatList: this.chatList
          .filter((chatItem) => !!chatItem.pairToken || !!chatItem.bill),
      };
    },
  }
</script>
